import toast from './Toast';

export default toast;
